/* istanbul ignore file */
import { useQuery } from '@apollo/client';
import { useApolloClient, ApolloError } from '@apollo/client';
import { setInitialStore, fmtStoreError } from '@catalogo/service-americanas-product/src/helpers/near-store';
import { getIn } from 'seamless-immutable';
import { getProduct } from '../cache/product';
import { getNearStoreServiceAcom, getSelectedStore } from '../queries/store.graphql';
import { fmtStores } from '../helpers/store';

const getError = (storeError: ApolloError, storeData: { [key: string]: string }, loading: boolean) => {
  const store = getIn(storeData, ['store', 'capacity']);
  const notFound = store ? store.length === 0 : false;
  const hasError = storeError || notFound;

  if (loading) {
    return null;
  }

  if (hasError) {
    return fmtStoreError(storeError, storeData);
  }

  if (!storeData) {
    return { errorCode: 'STORE_INITIAL_MESSAGE' };
  }
};

export const useStore = ({
  parsedQs,
  routeId,
  productId,
  cookies,
}: {
  parsedQs: { [key: string]: string };
  routeId: string;
  productId: string;
  cookies: {
    persistentCep: string;
  };
}) => {
  const client = useApolloClient();
  const product = getProduct({ client, id: productId, parsedQs, routeId });
  const { persistentCep } = cookies;
  const lasaOffer = getIn(product, ['lasaOffer']);
  const skuId = getIn(lasaOffer, ['sku']);
  const sellerId = getIn(lasaOffer, ['seller', 'id']);

  const { loading, data, error: storeError } = useQuery(getNearStoreServiceAcom, {
    variables: {
      cep: persistentCep,
      radius: 35,
      skuId,
      sellerId,
    },
    skip: !persistentCep || !skuId || !sellerId,
    ssr: false,
    onCompleted: setInitialStore,
    fetchPolicy: 'network-only',
    onError: setInitialStore,
  });

  const { data: selectedStoreData } = useQuery(getSelectedStore);
  const storesData = getIn(data, ['store', 'capacity'], []);
  const stores = storesData !== null ? storesData : [];
  const selectedStore = getIn(selectedStoreData, ['selectedStore']);
  const error = getError(storeError as ApolloError, data, loading);

  return { data: fmtStores(stores, selectedStore), error, loading, product, selectedStore };
};
